import LegacyTitle, { LegacyTitleProps } from './LegacyTitle';
import NewTitle, { NewTitleProps } from './NewTitle';

interface NewProps extends NewTitleProps {
  legacy?: false | undefined;
}

interface LegacyProps extends LegacyTitleProps {
  legacy: true;
}

type TitleProps = NewProps | LegacyProps;

const Title = (props: TitleProps) => {
  if (props.legacy) {
    return <LegacyTitle {...props} />;
  }
  return <NewTitle {...props} />;
};
export default Title;
